import { useEffect, useState } from 'react'
import { practicesStore } from '../services/practicesStore'

export function usePractices() {
  const [practices, setPractices] = useState(practicesStore.getAll())
  const [extraCourseCodes, setExtraCourseCodes] = useState(
    practicesStore.getExtraCourseCodes(),
  )

  useEffect(
    () =>
      practicesStore.subscribe(() => {
        setPractices(practicesStore.getAll())
        setExtraCourseCodes(practicesStore.getExtraCourseCodes())
      }),
    [],
  )

  return { practices, extraCourseCodes }
}
